import {SimulationResultContract, SimulationTradeRecord} from "./TradeSimulationRecords";
import {IsoDate} from "../../pseudo-types/DateTypes";

export class SimulationTrade {

    private _optionCode: string | null;
    private _quantity: number | null;
    private _date: IsoDate | null;
    private _price: number | null;

    private _hasChanges = false;

    /** @ngInject */
    private constructor(private readonly record: SimulationTradeRecord,
                        public readonly hasError: boolean,
                        public readonly contract?: SimulationResultContract) {
    }

    public get code(): string {
        if (this._optionCode == null) {
            return this.record.code;
        } else {
            return this._optionCode;
        }
    }

    public set code(code: string) {
        this._optionCode = code;
        this._hasChanges = true;
    }

    public get quantity(): number {
        if (this._quantity == null) {
            return this.record.quantity;
        } else {
            return this._quantity;
        }
    }

    public set quantity(value: number) {
        this._quantity = value;
        this._hasChanges = true;
    }

    public get date(): IsoDate {
        if (this._date == null) {
            return this.record.tradeDate;
        }
        return this._date;
    }

    public set date(value: IsoDate) {
        this._date = value;
        this._hasChanges = true;
    }

    public get price(): number {
        if (this._price == null) {
            return this.record.price;
        }
        return this._price;
    }

    public set price(value: number) {
        this._price = value;
        this._hasChanges = true;
    }

    public get hasChanges(): boolean {
        return this._hasChanges;
    }

    public toRecord(): SimulationTradeRecord {
        return {
            code: this.code,
            quantity: this.quantity,
            tradeDate: this.date,
            price: this.price
        };
    }

    public static from(record: SimulationTradeRecord,
                       hasError: boolean = false,
                       contract?: SimulationResultContract): SimulationTrade {
        return new SimulationTrade(record, hasError, contract);
    }
}
